var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 519 384"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bg-left_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26904",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h519v384H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg-left_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 136",
    transform: "translate(860 416)",
    stroke: "#707070",
    fill: "url(#bg-left_svg__a)",
    d: "M0 0h1060v664H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg-left_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 135",
    transform: "translate(.487 .44)",
    fill: "url(#bg-left_svg__a)",
    d: "M0 0h1245v1131H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-left_svg__a",
    x1: 0.5,
    x2: 0.496,
    y2: 0.313,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7ccad",
    stopOpacity: 0.322
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#f7ccad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ccad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 475",
    opacity: 0.64,
    clipPath: "url(#bg-left_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 4",
    transform: "rotate(180 865 400)",
    opacity: 0.5,
    clipPath: "url(#bg-left_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 218",
    transform: "translate(1149.513 415.561)",
    clipPath: "url(#bg-left_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59",
    d: "M1003.689 93.216S949.895 0 842.311 0H404.295S296.706 0 242.917 93.216L23.909 472.587s-53.794 93.167 0 186.333l219.008 379.372s53.789 93.167 161.378 93.167h438.016s107.584 0 161.378-93.167L1222.7 658.92s53.794-93.167 0-186.333z",
    transform: "translate(-.869 -.29)",
    fill: "url(#bg-left_svg__a)"
  })))))));
}
export default SvgBgLeft;